// extracted by mini-css-extract-plugin
export default {"form-wrapper":"Edit_form-wrapper__-eBYX","form-groups":"Edit_form-groups__scRJL","btn-container":"Edit_btn-container__Tk+1l","submit-btn":"Edit_submit-btn__hkFp8"};